<div class="pm-container">
  <div class="pm-header">
    <div class="pm-icon">
      <mat-icon>group_add</mat-icon>
    </div>
    <h2 class="pm-title">{{ title }}</h2>
  </div>

  <div class="pm-body">
    <mat-form-field appearance="outline" class="pm-field">
      <mat-label>{{ label }}</mat-label>
      <input
        type="text"
        matInput
        [(ngModel)]="promptValue"
        (keyup.enter)="accept()"
        autofocus
        required
      />
    </mat-form-field>
  </div>

  <div class="pm-actions">
    <button class="pm-btn pm-btn--cancel" (click)="close()">Cancelar</button>
    <button
      class="pm-btn pm-btn--accept"
      (click)="accept()"
      [disabled]="!promptValue"
    >
      Crear
    </button>
  </div>
</div>
